module.exports = __webpack_public_path__ + "static/z16-2-0002-tablet-33f084859c8cc54446d50e402e74645f.jpg";